import styled, { css } from 'styled-components';

export const ListItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const Item = styled.li`
  ${({ theme, $isMultipleIps }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    width: 100%;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: ${$isMultipleIps ? '12px' : '6px'};
    }
  `}
`;

export const ItemLabelWrapper = styled.div`
  ${({ theme }) => css`
  
    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: flex;
      flex-direction: column;
      gap: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  `}
`;

export const ItemLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.description};    
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      width: 100%;      
    }

    svg {
      position: relative;
      top: 3px;

      @media (max-width: ${theme.v2.breakpoints.md}) {
        top: 0;
      }
    }

  `}
`;

export const ItemValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.description};
    color: ${theme.v2.colors.neutral.lowPure};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      width: 100%;      
    }    
  `}
`;

export const IpColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const IpColumnText = styled.span``;
